import { DayPicker } from 'react-day-picker'
import { ChevronLeft, ChevronRight } from 'lucide-react'

interface CalendarGridProps {
  selected?: Date
  onSelect: (day: Date | undefined) => void
}

export function CalendarGrid({ selected, onSelect }: CalendarGridProps) {
  return (
    <DayPicker
      mode="single"
      selected={selected}
      defaultMonth={selected}
      onSelect={onSelect}
      showOutsideDays
      className="p-0"
      classNames={{
        months: 'flex flex-col',
        month: 'space-y-2',
        caption: 'relative flex items-center justify-center py-1',
        caption_label: 'text-foreground type-ui-sm font-medium',
        nav: 'flex items-center',
        nav_button:
          'text-foreground-secondary hover:text-foreground hover:border-hover border-border size-7 grid cursor-pointer place-items-center rounded-[var(--radius-size-md)] corner-squircle border bg-transparent transition-colors',
        nav_button_previous: 'absolute left-0',
        nav_button_next: 'absolute right-0',
        table: 'w-full border-collapse',
        head_row: 'flex justify-around',
        head_cell: 'text-foreground-secondary w-8 text-center text-xs font-normal',
        row: 'mt-1 flex w-full justify-around',
        cell: 'relative rounded-lg corner-smooth p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([aria-selected])]:rounded-lg',
        day: 'text-foreground-secondary hover:bg-element-hover hover:text-foreground h-8 w-8 cursor-pointer rounded-lg corner-smooth bg-transparent p-0 text-sm font-normal transition-colors aria-selected:bg-info aria-selected:text-on-info aria-selected:font-semibold aria-selected:hover:bg-info-hover',
        day_selected: '',
        day_today: 'text-foreground font-semibold ring-1 ring-foreground/20 rounded-lg corner-smooth',
        day_outside: 'text-foreground-placeholder opacity-50',
        day_disabled: 'text-foreground-disabled cursor-default',
        day_hidden: 'invisible',
      }}
      components={{
        // @ts-expect-error react-day-picker v8 icon component typing
        IconLeft: () => <ChevronLeft className="size-4" />,
        // @ts-expect-error react-day-picker v8 icon component typing
        IconRight: () => <ChevronRight className="size-4" />,
      }}
    />
  )
}
